const AutumnLeagueIcon = ({ width = '100%', height = null }) => {
  return (
    <svg
      width={width}
      height={height || 'auto'}
      viewBox="0 0 313 344"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_4869_90119)">
        <path
          d="M287.146 72.694L163.956 10.4989C161.813 9.40954 159.446 8.83942 157.045 8.83402C154.644 8.82862 152.275 9.38809 150.127 10.4678L26.1028 72.6629C21.5139 74.9953 18.3465 79.4578 17.6975 84.5889C17.4967 86.0971 0.00620842 236.05 149.664 317.945C151.964 319.208 154.548 319.858 157.168 319.833C159.788 319.809 162.359 319.111 164.636 317.805C308.438 236.034 296.185 91.2126 295.598 85.0864C295.345 82.4703 294.437 79.9614 292.959 77.7943C291.481 75.6271 289.481 73.8724 287.146 72.694Z"
          fill="white"
        />
      </g>
      <path
        d="M274.295 81.7114L163.226 25.6358C161.293 24.6537 159.16 24.1397 156.995 24.1348C154.83 24.1299 152.694 24.6344 150.758 25.6078L38.9362 81.6834C34.7988 83.7862 31.943 87.8097 31.3579 92.4359C31.1768 93.7957 15.4073 228.994 150.34 302.832C152.414 303.97 154.743 304.556 157.105 304.534C159.468 304.512 161.786 303.882 163.839 302.705C293.491 228.98 282.444 98.4079 281.915 92.8845C281.687 90.5258 280.868 88.2638 279.535 86.3098C278.203 84.3559 276.4 82.7738 274.295 81.7114Z"
        fill="#FFD60D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M157.635 36.8128L157.62 36.8051C157.417 36.7023 157.194 36.6484 156.967 36.6479C156.74 36.6474 156.517 36.7002 156.314 36.8022L156.304 36.8074L44.5265 92.8607C44.035 93.1168 43.7489 93.5723 43.6928 94.0157L43.6876 94.0569L43.6821 94.098C43.6835 94.0874 43.6824 94.0974 43.6792 94.1276C43.5536 95.3005 40.1659 126.928 52.0894 166.853C64.2119 207.444 92.1591 256.75 156.28 291.839L156.294 291.846C156.507 291.963 156.747 292.024 156.99 292.021C157.233 292.019 157.472 291.954 157.683 291.833L157.702 291.822L157.721 291.811C280.42 222.04 269.984 98.7674 269.539 94.0968C269.514 93.8435 269.427 93.6005 269.283 93.3907C269.14 93.1808 268.947 93.0108 268.721 92.8968L274.265 81.7706L268.719 92.896L157.635 36.8128ZM281.915 92.8845C282.444 98.4079 293.491 228.98 163.839 302.705C161.786 303.882 159.468 304.512 157.105 304.534C154.743 304.556 152.414 303.97 150.34 302.832C15.4073 228.994 31.1768 93.7957 31.3579 92.4359C31.943 87.8097 34.7988 83.7862 38.9362 81.6834L150.758 25.6078C152.694 24.6344 154.83 24.1299 156.995 24.1348C159.16 24.1397 161.293 24.6537 163.226 25.6358L274.295 81.7114C276.4 82.7738 278.203 84.3559 279.535 86.3098C280.868 88.2638 281.687 90.5258 281.915 92.8845Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.002 48.4668C157.528 48.4668 158.765 50.1028 158.765 52.121L158.765 81.1179C158.765 83.136 157.528 84.7721 156.001 84.772C154.475 84.772 153.238 83.136 153.238 81.1179L153.238 52.1209C153.238 50.1028 154.476 48.4668 156.002 48.4668Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.71 239.08C158.236 239.08 159.473 239.866 159.473 240.835V270.552C159.473 271.521 158.236 272.307 156.71 272.307C155.184 272.307 153.947 271.521 153.947 270.552V240.835C153.947 239.866 155.184 239.08 156.71 239.08Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M235.963 136.847C235.963 135.311 237.201 134.066 238.727 134.066H252.523C254.049 134.066 255.286 135.311 255.286 136.847C255.286 138.383 254.049 139.628 252.523 139.628H238.727C237.201 139.628 235.963 138.383 235.963 136.847Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.939 155.187C78.939 153.651 77.7018 152.406 76.1758 152.406H62.3797C60.8536 152.406 59.6165 153.651 59.6165 155.187C59.6165 156.723 60.8536 157.968 62.3797 157.968H76.1758C77.7018 157.968 78.939 156.723 78.939 155.187Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M194.474 64.7471C195.85 65.4117 196.43 67.0728 195.769 68.4573L188.74 83.1943C188.08 84.5788 186.429 85.1625 185.053 84.4979C183.678 83.8334 183.098 82.1723 183.758 80.7878L190.787 66.0507C191.448 64.6662 193.098 64.0826 194.474 64.7471Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M228.264 81.8869C229.365 82.9509 229.4 84.7111 228.342 85.8186L219.045 95.5365C217.987 96.6439 216.238 96.6791 215.138 95.6151C214.037 94.5511 214.002 92.7909 215.06 91.6834L224.357 81.9655C225.414 80.8581 227.164 80.8229 228.264 81.8869Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M257.353 101.326C258.181 102.616 257.811 104.337 256.529 105.17L237.716 117.38C236.433 118.212 234.723 117.841 233.896 116.55C233.069 115.26 233.438 113.539 234.72 112.706L253.534 100.496C254.816 99.6636 256.526 100.035 257.353 101.326Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M205.662 203.997C206.406 202.656 208.09 202.177 209.422 202.926L222.847 210.476C224.179 211.226 224.656 212.92 223.911 214.26C223.167 215.601 221.483 216.08 220.151 215.331L206.726 207.781C205.394 207.032 204.917 205.337 205.662 203.997Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M181.191 239.121C182.517 238.361 184.204 238.827 184.959 240.162L191.102 249.549C191.857 250.884 191.393 252.581 190.067 253.341C188.741 254.101 187.054 253.634 186.299 252.3L180.156 242.913C179.401 241.578 179.865 239.88 181.191 239.121Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M232.206 181.229C233.083 179.972 234.806 179.669 236.055 180.551L239.046 182.663C240.295 183.545 240.597 185.279 239.72 186.536C238.843 187.793 237.12 188.097 235.871 187.215L232.881 185.103C231.631 184.221 231.33 182.486 232.206 181.229Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.8692 183.518C79.0893 182.198 77.3936 181.764 76.0819 182.549L73.4458 184.127C72.1341 184.912 71.703 186.618 72.483 187.938C73.2629 189.258 74.9586 189.692 76.2703 188.907L78.9064 187.329C80.2181 186.545 80.6492 184.838 79.8692 183.518Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.688 136.847C76.688 135.311 75.4509 134.066 73.9248 134.066H60.1287C58.6026 134.066 57.3655 135.311 57.3655 136.847C57.3655 138.383 58.6026 139.628 60.1287 139.628H73.9248C75.4509 139.628 76.688 138.383 76.688 136.847Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M233.713 155.187C233.713 153.651 234.95 152.406 236.476 152.406H250.272C251.798 152.406 253.035 153.651 253.035 155.187C253.035 156.723 251.798 157.968 250.272 157.968H236.476C234.95 157.968 233.713 156.723 233.713 155.187Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.178 64.7471C116.802 65.4117 116.222 67.0728 116.882 68.4573L123.912 83.1943C124.572 84.5788 126.223 85.1625 127.598 84.4979C128.974 83.8334 129.554 82.1723 128.894 80.7878L121.865 66.0507C121.204 64.6662 119.554 64.0826 118.178 64.7471Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.3878 81.8869C83.2873 82.9509 83.2523 84.7111 84.3096 85.8186L93.6071 95.5365C94.6644 96.6439 96.4136 96.6791 97.5141 95.6151C98.6146 94.5511 98.6495 92.7909 97.5922 91.6834L88.2947 81.9655C87.2374 80.8581 85.4882 80.8229 84.3878 81.8869Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.2984 101.326C54.4713 102.616 54.8404 104.337 56.1229 105.17L74.9361 117.38C76.2185 118.212 77.9287 117.841 78.7559 116.55C79.583 115.26 79.2139 113.539 77.9314 112.706L59.1182 100.496C57.8357 99.6636 56.1256 100.035 55.2984 101.326Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.99 203.997C106.245 202.656 104.562 202.177 103.23 202.926L89.8046 210.476C88.4725 211.226 87.9961 212.92 88.7406 214.26C89.485 215.601 91.1685 216.08 92.5007 215.331L105.926 207.781C107.258 207.032 107.734 205.337 106.99 203.997Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M131.461 239.122C130.135 238.362 128.448 238.828 127.693 240.163L121.55 249.55C120.795 250.884 121.258 252.582 122.585 253.342C123.911 254.102 125.598 253.635 126.353 252.301L132.496 242.914C133.251 241.579 132.787 239.881 131.461 239.122Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.4455 181.229C79.5688 179.972 77.8455 179.669 76.5964 180.551L73.606 182.663C72.3569 183.545 72.055 185.279 72.9318 186.536C73.8085 187.793 75.5318 188.097 76.7809 187.215L79.7713 185.103C81.0204 184.221 81.3223 182.486 80.4455 181.229Z"
        fill="#FEAC06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M232.783 183.518C233.563 182.198 235.258 181.764 236.57 182.549L239.206 184.127C240.518 184.912 240.949 186.618 240.169 187.938C239.389 189.258 237.693 189.692 236.382 188.907L233.745 187.329C232.434 186.545 232.003 184.838 232.783 183.518Z"
        fill="#FEAC06"
      />
      <path
        d="M212.725 111.616H198.249V105.282C198.249 104.586 197.682 104.016 196.99 104.016H116.428C115.736 104.016 115.169 104.586 115.169 105.282V111.616H100.693C98.8571 111.616 97.0962 112.35 95.7978 113.657C94.4994 114.963 93.77 116.735 93.77 118.583V142.018C93.77 154.955 103.211 165.707 115.515 167.67C117.939 186.07 132.635 200.574 151.045 202.585V219.243H120.204C117.419 219.243 115.169 221.507 115.169 224.31V229.424C115.169 230.121 115.736 230.691 116.428 230.691H196.99C197.682 230.691 198.249 230.121 198.249 229.424V224.31C198.249 221.507 195.999 219.243 193.214 219.243H162.374V202.585C180.783 200.574 195.479 186.07 197.903 167.67C210.207 165.707 219.648 154.955 219.648 142.018V118.583C219.648 116.735 218.919 114.963 217.62 113.657C216.322 112.35 214.561 111.616 212.725 111.616ZM115.169 155.889C109.332 154.005 105.099 148.494 105.099 142.018V123.017H115.169V155.889ZM208.319 142.018C208.319 148.51 204.086 154.021 198.249 155.889V123.017H208.319V142.018Z"
        fill="#FE9B06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M284.299 212.626C192.408 162.594 110.559 168.355 29.0912 212.634V188.209L8.70898 174.656C101.888 124.012 199.108 117.166 304.709 174.663L284.299 188.209V212.626Z"
        fill="#5D33C3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M173.011 162.442L180.141 162.841L179.912 167.01L168.06 166.345L169.207 145.505L173.928 145.77L173.011 162.442ZM139.842 166.713L144.567 166.549L144.122 153.6L144.173 153.602L152.861 166.261L157.587 166.097L156.863 145.237L152.139 145.401L152.587 158.35L152.537 158.349L143.844 145.688L139.119 145.853L139.842 166.713ZM130.728 155.124L130.603 155.139L127.759 167.788L124.958 168.109L119.358 156.424L119.233 156.438L119.652 168.843L114.954 169.38L114.455 148.428L119.452 147.858L125.381 159.301L128.598 146.812L133.595 146.24L137.795 166.769L133.097 167.306L130.728 155.124ZM105.239 171.658C110.429 170.685 112.718 167.58 111.776 162.508L109.324 149.28L104.675 150.15L106.876 162.011C107.514 165.442 106.66 166.632 104.387 167.058C102.114 167.485 100.891 166.685 100.254 163.252L98.0527 151.392L93.4038 152.264L95.8593 165.491C96.8005 170.565 100.05 172.632 105.239 171.658ZM76.4736 156.341L90.6505 152.884L91.6298 156.94L86.8395 158.114L90.7557 174.343L86.1608 175.464L82.244 159.226L77.4538 160.395L76.4736 156.341ZM73.1739 179.407C78.2436 177.918 80.2127 174.598 78.7733 169.644L75.0193 156.723L70.4814 158.056L73.8471 169.64C74.8211 172.992 74.0897 174.262 71.869 174.914C69.6483 175.566 68.352 174.892 67.3788 171.541L64.0122 159.957L59.4743 161.29L63.2291 174.21C64.6684 179.165 68.1043 180.896 73.1739 179.407ZM59.7149 183.214L64.5107 181.527L49.753 164.603L45.6224 166.055L44.5695 188.539L49.3646 186.852L49.4419 182.402L56.897 179.781L59.7149 183.214ZM49.7818 171.427L49.8293 171.411L54.0071 176.375L49.5914 177.928L49.7818 171.427ZM189.001 151.157L196.102 151.938L196.552 147.788L184.751 146.491L182.502 167.239L194.305 168.538L194.754 164.387L187.653 163.607L188.106 159.431L194.906 160.18L195.356 156.029L188.555 155.281L189.001 151.157ZM216.002 172.148L210.995 171.275L210.191 166.898L202.41 165.539L200.19 169.388L195.183 168.515L206.979 149.389L211.291 150.14L216.002 172.148ZM208.063 156.126L208.014 156.118L204.704 161.703L209.313 162.508L208.063 156.126ZM225.78 175.005C229.734 175.99 234.521 174.865 236.884 170.007L237.97 165.611L228.669 163.288L227.791 166.85L232.43 168.008C231.819 170.488 229.295 171.372 227.099 170.821C224.267 170.114 222.661 166.742 223.509 163.304C224.374 159.792 227.364 157.541 230.196 158.248C231.116 158.454 231.962 158.91 232.641 159.567C233.32 160.224 233.806 161.056 234.046 161.973L237.866 159.407C237.21 158.028 236.244 156.822 235.044 155.885C233.844 154.947 232.443 154.304 230.953 154.006C225.289 152.596 219.984 156.25 218.549 162.07C217.122 167.865 220.36 173.652 225.78 175.005ZM254.767 175.481C253.205 180.395 249.726 182.035 244.697 180.417C239.668 178.798 237.782 175.428 239.345 170.514L243.419 157.699L247.924 159.148L244.271 170.639C243.213 173.963 243.913 175.251 246.117 175.961C248.32 176.671 249.632 176.03 250.689 172.706L254.343 161.215L258.848 162.666L254.767 175.481ZM265.687 169.706L272.362 172.264L273.839 168.367L262.745 164.115L255.362 183.62L266.457 187.873L267.933 183.972L261.258 181.413L262.744 177.488L269.137 179.939L270.613 176.034L264.22 173.584L265.687 169.706Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_4869_90119"
          x="0.975098"
          y="0.833984"
          width="311.114"
          height="343"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0196078 0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4869_90119"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4869_90119"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default AutumnLeagueIcon;
